import { z } from 'zod';

export const NEW_SCRATCHPAD_SETTINGS = {
  value: 'create_new_scratchpad',
  label: 'Create new scratchpad',
} as const;

export const addToScratchpadSchema = z.object({
  scratchpadId: z.string().min(1, 'Scratchpad is required'),
  // Only required if creating new scratchpad
  name: z.string().optional(),
});

export type IAddToScratchpadFormState = z.infer<typeof addToScratchpadSchema>;
